// extracted by mini-css-extract-plugin
export var hamburger = "hamburger-module--hamburger--jCMeU";
export var isActive = "hamburger-module--is-active---XxU3";
export var hamburgerInner = "hamburger-module--hamburger-inner--3miLR";
export var hamburgerBox = "hamburger-module--hamburger-box--2Bjyx";
export var hamburgerSqueeze = "hamburger-module--hamburger-squeeze--3wJOb";